import { Link } from 'react-router';
import RegisterForm from '@/components/auth/RegisterForm';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { isSelfRegistrationEnabled } from '@/lib/registration';

export default function Register() {
    if (isSelfRegistrationEnabled()) {
        return <RegisterForm />;
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-green-50 to-blue-50 p-4">
            <Card className="w-full max-w-md p-8 text-center">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Invite only</h1>
                <p className="text-gray-600 mb-6">
                    Light2Live is invite-only. Ask your coach for an invitation, then follow the
                    link in your email to set up your account.
                </p>
                <Link to="/">
                    <Button className="w-full bg-linear-to-r from-green-400 to-blue-500 hover:opacity-90">
                        Sign in
                    </Button>
                </Link>
            </Card>
        </div>
    );
}
